export default __webpack_public_path__ + "static/key_features_logo-76d8d485674655f9270a970671c67790.png";